import {addRemoveCouponsListener} from './coupon.js';

document.addEventListener('DOMContentLoaded', addRemoveCouponsListener);